import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as JsBarcode from 'jsbarcode';
import { QRCodeToDataURLOptions } from 'qrcode';
import { EtiquetaMarcopolo } from 'src/app/_models/etiqueta-marcopolo';

@Component({
  selector: 'app-etiqueta-marcopolo',
  templateUrl: './etiqueta-marcopolo.component.html',
  styleUrls: ['./etiqueta-marcopolo.component.scss']
})
export class EtiquetaMarcopoloComponent implements OnChanges {

  @Input()
  etiqueta: EtiquetaMarcopolo | null = null;

  @Input()
  largura: number | null = null;

  @Input()
  altura: number | null = null;

  menorMedida: number | null = null;

  barcodeConfig: JsBarcode.Options | null = null;

  qrCodeConfig: QRCodeToDataURLOptions | null = null;

  constructor () { }

  ngOnChanges (changes: SimpleChanges): void {

    if (
      changes['largura'] ||
      changes['altura']
    )
      this.tratarMudancaDeTamanho();
  }

  private tratarMudancaDeTamanho (): void {

    this.menorMedida = this.largura! > this.altura! ? this.altura : this.largura;

    this.barcodeConfig = {
      margin: 0,
      width: Math.ceil(this.menorMedida! / 300),
      height: Math.floor(this.menorMedida! * 0.08),
      displayValue: false
    };

    this.qrCodeConfig = {
      margin: 0,
      scale: Math.floor(this.altura! / 130)
    }
  }
}
